import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var UploadCloud01 = function UploadCloud01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M4 16.2422c-1.206-.8072-2-2.182-2-3.7422 0-2.3436 1.7915-4.2687 4.0797-4.4806C6.5478 5.172 9.0202 3 12 3s5.4522 2.1721 5.9203 5.0194C20.2085 8.2313 22 10.1564 22 12.5c0 1.5602-.794 2.935-2 3.7422M8 16l4-4m0 0 4 4m-4-4v9"
    })
  }));
};
export default UploadCloud01;